import React, { HTMLAttributes } from 'react'
import { styles } from './Quote.css'
import { AppText } from '@otomoro/components/shared/AppText'
import { PortableText, PortableTextComponents } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { QuoteIcon } from '@otomoro/components/icons/QuoteIcon'

interface QuoteProps extends HTMLAttributes<Element> {
	quote: PortableTextObject
	author: string
	profession: string
}

export const Quote: React.FC<QuoteProps> = ({ quote, author, profession }) => {
	const { base, quoteLogoWrapper, quoteLogo, quoteText, authorWrapper, inner } = styles()

	const components = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" size="intro" weight="medium" className={quoteText()}>
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	return (
		<blockquote className={base()}>
			<div className={inner()}>
				<div className={quoteLogoWrapper()}>
					<QuoteIcon className={quoteLogo()} />
				</div>
				<PortableText value={quote} components={components} />
				<footer className={authorWrapper()}>
					<AppText as="p" weight="medium" className="!text-[2.2rem]">
						{author}
					</AppText>
					<AppText as="p" size="base" weight="medium" color="black">
						{profession}
					</AppText>
				</footer>
			</div>
		</blockquote>
	)
}
